import script from "./Dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=723f8958&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723f8958"]])

export default __exports__